
  export const HTMLInfoDivideHalf = (html: string) => {
    const marker = '<!--SPLIT-->';
    if (html.includes(marker)) {
      // Create a temporary div to parse the HTML before and after the marker
      const [first, second] = html.split(marker, 2);
  
      const firstDiv = document.createElement('div');
      firstDiv.innerHTML = first;
  
      const secondDiv = document.createElement('div');
      secondDiv.innerHTML = second;
  
      return [firstDiv.innerHTML, secondDiv.innerHTML];
    }


    const div = document.createElement('div');
    div.innerHTML = html;
    const nodes = Array.from(div.childNodes);
  
    const half = Math.ceil(nodes.length / 2);
  
    const firstHalf = document.createElement('div');
    nodes.slice(0, half).forEach((node) => firstHalf.appendChild(node.cloneNode(true)));
  
    const secondHalf = document.createElement('div');
    nodes.slice(half).forEach((node) => secondHalf.appendChild(node.cloneNode(true)));
  
    const HTMLFirstHalf = firstHalf.innerHTML;
    const HTMLSecondHalf = secondHalf.innerHTML;
  
    return [HTMLFirstHalf, HTMLSecondHalf];
  }

  export const HTMLInfoDivideBySpecificText = (html: string, specificText: string) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    const nodes = Array.from(div.childNodes);

    const specificIndex = nodes.findIndex((node) => {
      return node.nodeType === 3 && node.nodeValue?.includes(specificText);
    });

    if (specificIndex === -1) {
      return [];
    }

    const firstPart = document.createElement('div');
    nodes.slice(0, specificIndex).forEach((node) => firstPart.appendChild(node.cloneNode(true)));

    const secondPart = document.createElement('div');
    nodes.slice(specificIndex).forEach((node) => secondPart.appendChild(node.cloneNode(true)));

    const HTMLFirst = firstPart.innerHTML;
    const HTMLSecond = secondPart.innerHTML;

  return [HTMLFirst, HTMLSecond];
  }
  